function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawPieChart = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1000.85 836.99",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 812.95,
    y1: 789.59,
    x2: 812.95,
    y2: 221.38,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), React.createElement("path", {
    d: "M319.99 31.27C350.77 3.84 399.1-1.73 443.08.43c138.16 6.87 262.87 73.56 370.74 149 39.05 27.31 77.5 56.74 102.85 94.35 51.6 76.57 36.3 182.63-35.46 245.7-24.41 21.46-54 37.92-84.39 52.5-54 25.93-112.31 46.74-173.62 52.67-43.73 4.22-88 .79-131.46-5.11-121.44-16.47-240.65-52.89-340.56-115.2-43.82-27.33-85.13-61.3-103.19-105.51s-6.5-100.24 38.24-126.41c18.51-10.82 40.64-15.71 62.3-20.3 31.89-6.76 64.29-13.42 93.06-27.15 29.72-14.19 64.92-41.63 59-73-6.28-33.71-11.35-63.3 19.4-90.7z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 967.42,
    cy: 831.34,
    rx: 33.42,
    ry: 5.65,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 393.44,
    cy: 761.68,
    rx: 148.72,
    ry: 26.33,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 792.81,
    cy: 756.47,
    rx: 75.59,
    ry: 16.65,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M974.32 759.99s6.14 8-2.83 20.14-16.36 22.35-13.37 29.9c0 0 13.53-22.5 24.54-22.82s3.76-13.71-8.34-27.22z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M974.32 759.99a10 10 0 0 1 1.26 2.52c10.74 12.63 16.47 24.41 6.14 24.7-9.62.28-21.17 17.49-23.93 21.83a8.21 8.21 0 0 0 .33 1s13.53-22.5 24.54-22.82 3.76-13.72-8.34-27.23z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M985.73 770.22c0 2.83-.32 5.11-.71 5.11s-.71-2.28-.71-5.11.4-1.49.79-1.49.63-1.33.63 1.49z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M989.65 773.59c-2.48 1.35-4.65 2.17-4.83 1.83s1.67-1.72 4.15-3.07 1.5-.37 1.69 0 1.47-.11-1.01 1.24z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M941.91 759.99s-6.14 8 2.83 20.14 16.37 22.35 13.38 29.9c0 0-13.54-22.5-24.55-22.82s-3.78-13.71 8.34-27.22z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M941.91 759.99a9.83 9.83 0 0 0-1.25 2.52c-10.75 12.63-16.48 24.41-6.15 24.7 9.63.28 21.17 17.49 23.93 21.83-.09.34-.2.67-.32 1 0 0-13.54-22.5-24.55-22.82s-3.78-13.72 8.34-27.23z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M930.5 770.22c0 2.83.32 5.11.71 5.11s.71-2.28.71-5.11-.4-1.49-.79-1.49-.63-1.33-.63 1.49z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M926.59 773.59c2.48 1.35 4.64 2.17 4.83 1.83s-1.68-1.72-4.16-3.07-1.5-.37-1.68 0-1.47-.11 1.01 1.24z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M932.42 808.98s17.15-.53 22.32-4.21 26.4-8.08 27.68-2.17 25.78 29.37 6.41 29.52-45-3-50.17-6.16-6.24-16.98-6.24-16.98z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M989.22 830.07c-19.37.15-45-3-50.17-6.16-3.93-2.4-5.5-11-6-14.95h-.57s1.08 13.84 6.24 17 30.8 6.32 50.17 6.16c5.59 0 7.52-2 7.42-5-.8 1.8-2.89 2.91-7.09 2.95z",
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 33.42,
    cy: 789.34,
    rx: 33.42,
    ry: 5.65,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M10.97 763.09s19.07-.59 24.81-4.68 29.33-9 30.76-2.41 28.65 32.63 7.13 32.81-50-3.36-55.75-6.85-6.95-18.87-6.95-18.87z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M74.05 786.5c-21.53.17-50-3.35-55.75-6.85-4.37-2.66-6.11-12.2-6.69-16.61h-.64s1.21 15.38 7 18.87 34.22 7 55.75 6.85c6.21 0 8.36-2.27 8.24-5.54-.92 2.03-3.29 3.28-7.91 3.28z",
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 156.3,
    cy: 810.53,
    rx: 36.41,
    ry: 6.16,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M171.35 800.5a10.6 10.6 0 0 0 3.48-5.24c.44-2.08-.44-4.58-2.43-5.34-2.23-.85-4.61.7-6.41 2.26s-3.88 3.34-6.24 3a9.51 9.51 0 0 0 2.94-8.89 3.67 3.67 0 0 0-.82-1.8c-1.24-1.33-3.48-.76-5 .28-4.71 3.32-6 9.71-6.05 15.47-.47-2.08-.07-4.24-.09-6.37s-.59-4.49-2.39-5.64a7.23 7.23 0 0 0-3.65-.86c-2.11-.07-4.47.14-5.92 1.69-1.79 1.92-1.33 5.15.23 7.27s3.94 3.44 6.13 4.9a13.57 13.57 0 0 1 4.38 4.18 4.71 4.71 0 0 1 .33.75h13.27a36.9 36.9 0 0 0 8.24-5.66zM412.48 469.54l-6.16-1.83.29 4.48 13.79 5.27-2.5-7.42-5.42-.5z",
    fill: primaryColor
  }), React.createElement("path", {
    opacity: 0.03,
    d: "M412.48 469.54l-6.16-1.83.29 4.48 13.79 5.27-2.5-7.42-5.42-.5z"
  }), React.createElement("path", {
    d: "M608.63 669.75a283.49 283.49 0 0 0 81.79-199.62v-2.41H406.6z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M608.63 669.75a283.49 283.49 0 0 0 81.79-199.62v-2.41H406.6z",
    opacity: 0.03
  }), React.createElement("path", {
    d: "M608.63 674.22a283.49 283.49 0 0 0 81.79-199.62v-2.41H406.6z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M608.63 674.22a283.49 283.49 0 0 0 81.79-199.62v-2.41H406.6z",
    fill: "#fff",
    opacity: 0.15
  }), React.createElement("path", {
    d: "M966.38 456L962 416.47s-7.93-35.59-9.06-53.38-9.7-19.09-9.77-19.09-10.57-6.18-11.51-8.24c-.73-1.58-6.6-4.94-9.26-6.42l-1.3-.69s-3.3-13.75-7.23-11.78l-.32-.93a34.41 34.41 0 0 1-1.85-9.17v-1.15a33.56 33.56 0 0 0 9-15.33 33.14 33.14 0 0 0 1-6.26v-1.19c1.93-1.35 2.25-4.21 2.76-6.6.94-4.38 3.4-8.3 4.57-12.62.1-.37.18-.75.25-1.14v-.25a14.78 14.78 0 0 0 .23-2.4v-.17c0-3.26-1-6.46-3.7-8.2a8 8 0 0 1-1.72-1.2 5.15 5.15 0 0 1-.88-1.59l-2-4.76a4.93 4.93 0 0 0-1-1.69 7.25 7.25 0 0 0-2.67-1.27c-3-1.15-5-3.94-6.47-6.72s-2.82-5.78-5.11-8c-3.72-3.55-9.24-4.3-14.36-4.86a15.49 15.49 0 0 0-.36 4.89c-8.13-1.78-17-3.49-24.49.1a5.67 5.67 0 0 0-3 2.9 4.05 4.05 0 0 0-.12.47 3.1 3.1 0 0 0 0 .61 5.51 5.51 0 0 1 .13 1.33 2 2 0 0 1-1.25 1.34c-2.46 1.09-5.43-.32-8 .55-2.35.8-3.65 3.27-4.38 5.63s-1.2 4.89-2.79 6.78c-.8 1-1.85 1.67-2.68 2.6a8 8 0 0 0-1.89 6.36 1.13 1.13 0 0 0 0 .18c0 .3.11.6.19.9a8.12 8.12 0 0 0 .38 1c.14.29.29.57.45.85 1.12 1.89 2.79 3.53 3.21 5.67v.08c.49 2.75-1.26 5.37-1.7 8.11 0 .22-.06.43-.07.65v.74c.15 4 3.82 6.65 6 9.59.58.78 1.66 3.05 2.82 3.9.06.43.13.85.22 1.26a32.63 32.63 0 0 0 3.26 9.3A34 34 0 0 0 875 312.79c0 .39.08.79.12 1.19 0 .74.1 1.5.1 2.24v1.08l-.33-2.54a9.83 9.83 0 0 0-3.76-.05 288.33 288.33 0 0 0-197.78-78.55v138.09c-8.26-2.48-15-2.76-14.5 3.08.46 6 7 12.08 14.5 17.11v131.09h144.24c.15 3.34.45 6.34 1 7.07 1.55 1.88 1.41 24.4 1.41 24.4s.76 4.13.95 4.87 2.45 19.86 2.45 20.79 2.08 7.5 1.89 10.12 3.4 11.23 3.4 11.23l.56 15.74s5.85 8.81 6.23 9.37.19 11.61 6.6 16.86a7.46 7.46 0 0 1 2.08 3.55c.48 1.9 16.58 28.94 21.56 37.28l-.6 2.83-4 18.71-.19 7.87s-2.46 6.74-1.7 9.55a10.25 10.25 0 0 1 .38 4.5s-2.64 4.11-.94 6.74.75 4.12-1.7 10.86c-1.08 3-.15 4.77 1.23 5.87 0 .33-.08.68-.12 1-.35 3-.74 6.43-.74 7.34s-.35 5-.37 8.6c0 2.85.18 5.41.94 5.83 1.7.93 11.14 2 11.32 5.24s3.78 7.86 11.32 7.86 20.57-2.62 23.77-2.25c.53.07.84-.28 1-.9a3 3 0 0 0 .07-.32 7.14 7.14 0 0 0 4.4 2.35c11.32 2.07 25.09-3 27.74-8.05a9.24 9.24 0 0 0 .76-2c1.26-5-.76-11.29-.76-11.29a19.26 19.26 0 0 1-.24-7.74 6.59 6.59 0 0 1 1.55-3.11c1.81-1.9 3.56-7.12 4.74-11.32.91-3.27 1.49-5.93 1.49-5.93s-1.19-1.82-3-4.32c-3.63-5.09-9.76-13-13.59-14.35a4.39 4.39 0 0 1-.4-1.18c-.18-1.87-4.15-8-4.15-8s-5.47-8.81-5.47-9.55-7.54-12.18-7.54-12.18-2.9-6.29-4.81-9.7c.22-.6.44-1.36.67-2.26 2-7.88 4-25.87 3.57-28.31-.57-3-1-6.18 1.88-10.49s2.65-11.23 2.65-11.23-.19-21.18 1.88-25.48 7.92-38.77 7.74-39.53S926 557 926 557l.35-13.59v-.83s1.32-11.8 3-14.43a6.28 6.28 0 0 0 .52-2.57H961c0-1.88-.07-3.75-.12-5.62h.12a285.87 285.87 0 0 0-3-39.17c2.92-3.54 6.45-6 6.56-6.76a41.65 41.65 0 0 1 2.07-6.75c1.26-3.79-.25-11.28-.25-11.28zm-62.83 293.13s.8-.48 2.1-1.15c.08.32.16.66.24 1 .84 3.62 1.85 8.64 1.62 11-.39 3.93-1 10.12-1 10.12a32.8 32.8 0 0 0-2.39 7c-.6-2.47-1.19-4.42-1.19-4.42s-12.84-8.6-12.84-12.92a33.86 33.86 0 0 0-.88-6.43c-.11-.54-.23-1.06-.35-1.57a11.24 11.24 0 0 1 1.42 2.21s3.83-9.29 4.75-13a3 3 0 0 0 .16-1.42 12.14 12.14 0 0 1-.23-3.84c.9 1 1.59 2 1.36 2.72-.52 1.71 7.23 10.7 7.23 10.7z",
    transform: "translate(-99.58 -31.5)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M805.01 756.85c-3.16-.37-16 2.23-23.46 2.23s-11-4.64-11.17-7.82-9.49-4.27-11.17-5.2c-.74-.42-.93-3-.92-5.8 0-3.57.36-7.61.36-8.55s.38-4.32.73-7.29c.3-2.57.58-4.8.58-4.8 8.75-10.61 28.68-2.8 28.68-2.8s.85 2.95 1.54 6.25a34.22 34.22 0 0 1 .87 6.39c0 4.29 12.67 12.85 12.67 12.85a84.58 84.58 0 0 1 2.1 8.83c.51 3.15.6 5.88-.81 5.71z",
    fill: "#53517c"
  }), React.createElement("path", {
    d: "M805.01 756.84c-3.16-.36-16 2.24-23.45 2.24s-11-4.65-11.17-7.82-9.5-4.28-11.18-5.21c-.74-.41-.93-3-.92-5.79 3.56 1.08 8.52 2.85 10.24 4.68 2.79 3 3.53 6.32 5.4 6.7s3.72 3 12.65.74c5.58-1.4 13.82-1.41 19.24-1.22.51 3.13.6 5.85-.81 5.68z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M839.08 725.95c-3.16 3.35-1.29 10.79-1.29 10.79s2.6 8.2 0 13.23-16.2 10-27.37 8a6.57 6.57 0 0 1-5.08-3.48c-2.73-5.38 1.91-14.77 1.91-14.77s.56-6.14.94-10.05c.22-2.36-.78-7.35-1.6-10.95-.55-2.36-1-4.13-1-4.13s17-24.39 22.16-24.57a2.34 2.34 0 0 1 .73.08c3.74.92 10.11 9.18 13.82 14.41 1.77 2.5 2.95 4.31 2.95 4.31s-2.99 13.78-6.17 17.13z",
    fill: "#53517c"
  }), React.createElement("path", {
    d: "M839.08 725.95c-3.16 3.35-1.29 10.79-1.29 10.79s2.6 8.2 0 13.22-16.2 10.06-27.37 8a6.58 6.58 0 0 1-5.08-3.47c3.22-.68 8.29-1.55 16.25-2.48 19.17-2.24 14.14-14.89 14.14-14.89s-2.23-8.94.56-13.41c2-3.17 4.63-13.5 6-19.2 1.78 2.49 2.95 4.3 2.95 4.3s-2.98 13.79-6.16 17.14zM790.18 723.07c-2.67-3.65-10.57-10.68-26.5 3.06a9 9 0 0 1-4.3-1.71c.3-2.57.58-4.8.58-4.8 8.75-10.61 28.68-2.8 28.68-2.8s.85 2.95 1.54 6.25z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M826.8 513.5v.82l-.38 13.53s-1.68 4.66-1.49 5.4-5.58 35-7.64 39.28-1.87 25.33-1.87 25.33.18 6.88-2.62 11.17-2.38 7.47-1.82 10.47c.46 2.42-1.55 20.31-3.52 28.14a9.79 9.79 0 0 1-1.33 3.51 2.77 2.77 0 0 0-.45.86c-2.68 6.91-9.6 49.59-9.6 49.59s-.07.82-.14 1.94c-.12 2.06-.23 5.16.14 5.88a3 3 0 0 1-.16 1.41c-.9 3.69-4.68 12.93-4.68 12.93s-7.26-16.2-27.56 1.3c0 0-7.82-.75-5.39-7.45s3.35-8.19 1.67-10.79.93-6.7.93-6.7a10.19 10.19 0 0 0-.37-4.47c-.75-2.79 1.68-9.49 1.68-9.49l.19-7.82 3.92-18.6 1.18-5.6 1.22-5.79 6.5-112.85.25-4.2 1.82-31.69 43.93-7.26 1.5 11.53 2.38 5.66z",
    fill: "#b3d7f7"
  }), React.createElement("path", {
    d: "M806.01 511.78L779.1 529.5l1 15.51s2.79 24.95 2.79 27.55-1.31 23.83-1.31 23.83 6.71 10 6 12.48 5.76 9.3 5.76 9.3l11.08 21.2s1.87 6.92 3 8.22a9.79 9.79 0 0 1-1.33 3.51c-2.23 2.23-10.05 50.45-10.05 50.45s-.07.82-.14 1.94c-.57-.51-1-.82-1-.82s-5.4-8.94-5.4-9.86-5.77-8.38-5.77-8.38l-13.16-25.13-3.08-5.21 1.22-5.79 8.57-148.74 43.93-7.26 1.5 11.53-40 10.19z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M824.56 513.5l-49.14 17.75 1.82-31.69 43.93-7.26 1.5 11.53 2.38 5.66c-.3 2.29-.49 4.01-.49 4.01zM796.08 709.37a3 3 0 0 1-.16 1.41c-.69-1.15-1.11-2.09-1-2.52.56-1.68-4.47-5.59-4.47-5.59s-5.39-8.94-5.39-9.86-5.78-8.38-5.78-8.38l-13-24.74 1.18-5.6 1.22-5.79 6.53-112.8.39 9.53s2.82 24.9 2.82 27.47-1.3 23.83-1.3 23.83 6.7 10 6 12.48 5.77 9.3 5.77 9.3l11.17 21.23s2 7.64 3.17 8.38a19.58 19.58 0 0 1 2.52 4.21c-2.68 6.91-9.6 49.59-9.6 49.59s-.07.82-.14 1.94c-.19 2.09-.3 5.19.07 5.91zM833.69 699.13s-8.38 15.08-14.71 15.46c-4.27.25-9.47 2.61-12.39 4.13-.55-2.36-1-4.13-1-4.13s17-24.39 22.16-24.57a2.34 2.34 0 0 1 .73.08v.09c.18 1.87 5.21 8.94 5.21 8.94z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M833.69 698.01s-8.38 15.08-14.71 15.46-14.7 5.4-14.7 5.4-7.64-8.94-7.09-10.61-4.46-5.59-4.46-5.59-5.4-8.94-5.4-9.86-5.78-8.38-5.78-8.38l-13.21-25.13s-22.15-37.25-22.71-39.48a7.37 7.37 0 0 0-2.06-3.53c-6.32-5.22-6.14-16.2-6.51-16.76l-6.14-9.31-.56-15.64s-3.54-8.56-3.35-11.17-1.87-9.12-1.87-10.06-2.23-19.91-2.41-20.66-.94-4.84-.94-4.84.19-22.34-1.29-24.21c-.82-1-1.08-6.27-1.14-10.85-.06-3.83 0-7.2 0-7.2l109.65-11.36s.68 6.25 1.07 12.51c.35 5.59.47 11.21-.32 12.44-1.68 2.61-3 14.34-3 14.34l-49.52 17.87.55 13.59s2.8 24.95 2.8 27.55-1.31 23.83-1.31 23.83 6.7 10 6 12.48 5.76 9.3 5.76 9.3l11.17 21.23s2.06 7.64 3.17 8.38 6.16 11.75 6.16 11.75 7.44 11.37 7.44 12.11 5.4 9.5 5.4 9.5 3.91 6.14 4.09 8 5.22 8.9 5.22 8.9z",
    fill: "#b3d7f7"
  }), React.createElement("path", {
    d: "M766.67 604.18s9.12 10.43 13.77 10.62-13.77-10.62-13.77-10.62zM801.48 706.58s27.55-14.15 24-7.63-13.59 10-13.59 10zM765.55 703.42s16.94 1.11 19.17 3.91c0 0-18.05-3.73-19.17-3.91zM765.73 709.19s15.46.56 20.48 2.79c0 0-16.38-.56-20.48-2.79z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M613.42 384.5l-4.9-2.24-7.76-3.54s-36.86-14.71-38-29.41 43 9.68 43 9.68a42.42 42.42 0 0 0 4.09 5.5c1.41 1.58 3 2.92 4.29 3.06 3.4.37-.72 16.95-.72 16.95zM818.42 304.81l-12.1 14-29.41-9.67-7.26-5.78 4.64-6.14c1.59-2.1 2.07-5.3 2-8.6 0-.74 0-1.5-.1-2.24a57.16 57.16 0 0 0-2.08-10.94s41.88-10.62 38.9-1.87a15.57 15.57 0 0 0-.7 5.63 34.11 34.11 0 0 0 1.83 9.12 53 53 0 0 0 3.15 7.59z",
    fill: "#c37871"
  }), React.createElement("path", {
    d: "M813.02 273.5a15.57 15.57 0 0 0-.7 5.63 33.51 33.51 0 0 1-36.12 7.18 57.16 57.16 0 0 0-2.08-10.94s41.88-10.59 38.9-1.87z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M822.33 254.17c0 .8 0 1.6-.09 2.39a33.51 33.51 0 0 1-63.12 13.15 32.88 32.88 0 0 1-3.21-9.24 32 32 0 0 1-.61-6.3 33.16 33.16 0 0 1 .46-5.49 33.5 33.5 0 0 1 66.53 4.34c.03.38.04.77.04 1.15z",
    fill: "#c37871"
  }), React.createElement("path", {
    d: "M818.42 304.81l-12.1 14-29.41-9.67-7.26-5.78 4.64-6.14c1.59-2.1 2.07-5.3 2-8.6l1.34 10.27.32.32 1.92 1.92h2.42l4.66 6.33s6.7-5.39 7.26-4.1 9.68-2.23 9.68-2.23h.35c8.26-.35 9.7-12.65 9.7-12.65s.13-.11.2-.15a53 53 0 0 0 3.15 7.59zM830.1 486.74c-.21.81-.44 1.6-.69 2.39-7.26 23.08-59.58 23.64-59.58 23.64l-1.49-14.33-5 9.68s-32.38-8.94-43.95-15.33c-.06-3.83 0-7.2 0-7.2l109.65-11.36s.67 6.27 1.06 12.51zM613.42 384.5l-4.9-2.24c1.13-5.32 1.33-15.88 1.36-17.77 1.41 1.58 3 2.92 4.29 3.06 3.37.37-.75 16.95-.75 16.95z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M828.47 434.39s8.2 29.42.94 52.51-59.58 23.6-59.58 23.6l-1.49-14.33-5 9.69s-39.09-10.81-46.72-17.14-3.73-15.82-3.73-15.82 2.61-12.28 4.84-14.9 2.61-11.73 1.86-13 2.61-13.6 3.73-15.46-.19-51.57-.19-51.57-16.57 7.44-17.5 9.68-20.48 13-20.48 13-18.43 2.24-21.78 2.24-21.79-2.24-21.79-2.24-5-.19-6.51-1.3a19.21 19.21 0 0 0-4.85-2.05s-5.2-1.12-6.7-3.16-14-8.94-14-8.94c2.42-1.49 2.61-21 2.61-21l23.64 5.77s1.5-3.16 3.73-1.86 15.83 2.39 15.83 2.39 11.36-2.23 11.92-1.31 2.23.75 2.23.75 2.24-.19 2.24-.92 2 .17 2 .17l3.73.56s-.56-4.83 1.12-5.2a2.46 2.46 0 0 0 1.85-2.05s5-6.7 7.45-6.7 4.1-6.7 4.1-6.7l8.94-9.12s-1.12-4.66 0-4.85 1.29-2.23 1.29-2.23.38-4.09 2.43-5 3.16-6.32 3.16-6.32 9.49-10.61 10.24-14.34 4.66-4.47 4.66-4.47a23 23 0 0 1 6.88-3c3.17-.56 11.55-1.5 11.55-1.5s15.26-1.29 16.76-3 4.09-1.5 5.76-1.5a1.91 1.91 0 0 0 1-.37c1.51-.94 3.31-3.56 5.11-5.21 2.23-2.05 6.14-1.12 6.14-1.12l1.68 12.85.31.31 1.92 1.92h2.42l4.66 6.34s6.7-5.4 7.26-4.1 9.68-2.24 9.68-2.24h.35c8.26-.35 9.7-12.64 9.7-12.64 4.1-3.55 7.64 11.36 7.64 11.36l1.29.69c2.62 1.46 8.42 4.8 9.13 6.38.93 2 11.36 8.18 11.36 8.18z",
    fill: "#53517c"
  }), React.createElement("path", {
    d: "M833.32 479.07l-5.5 4.43-6.23 5s-11.55 27-27.37 19.37 21.2-35.87 21.2-35.87l5.12-2.48 5.67-2.74z",
    fill: "#c37871"
  }), React.createElement("path", {
    d: "M776.84 302.5c-5.75 2.39-13 8.07-13 8.07l-.27-14.89c1.51-.95 3.31-3.56 5.11-5.22 2.23-2 6.14-1.11 6.14-1.11l1.68 12.84z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M777.96 300.28c-5.75 2.39-13 8.07-13 8.07l-.24-14.85c1.51-.94 3.31-3.56 5.11-5.21 2.23-2.05 6.14-1.12 6.14-1.12l1.68 12.85z",
    fill: "#e6eaed"
  }), React.createElement("path", {
    d: "M822.88 304.95c-2.86 7.66-6.42 16.14-7.06 12.89-.77-3.85-7.48-9.29-11.57-12.3 8.26-.34 9.7-12.64 9.7-12.64 4.1-3.54 7.64 11.36 7.64 11.36z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M822.88 301.6c-2.86 7.66-6.42 16.14-7.06 12.89-.77-3.85-7.48-9.29-11.57-12.3 8.26-.35 9.7-12.64 9.7-12.64 4.1-3.55 7.64 11.36 7.64 11.36z",
    fill: "#e6eaed"
  }), React.createElement("path", {
    d: "M784.91 595.62s21.22-3 20.29 1.49-20.29-1.49-20.29-1.49zM750.65 522.5s8.38-4.47 15.83-2.6zM737.06 510.35s13.41-2.05 18.43.19zM795.71 541.07s-11.73 12.47-11 15.82zM681.21 373.7s-1.86 6.7 9.5 9.49zM677.86 385.24s14 12.47 7.45 12.85-7.45-12.85-7.45-12.85zM708.95 335.16s17.13 11.91 16 14.71-16-14.71-16-14.71zM833.32 479.07l-5.5 4.43c-1.15-3.94-3.53-10.54-7.25-14l5.67-2.74z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M835.92 320.82l7.45-4.65s8.56 1.3 9.68 19 8.94 53.06 8.94 53.06l4.28 39.27s1.49 7.45.19 11.17a40.78 40.78 0 0 0-2 6.7c-.19 1.31-10.43 7.64-10.24 15.83s-13 15.82-13 15.82-8.57 5-11.36 8.57c0 0-3.17-14.9-10.05-18.62s14.52-33.32 14.52-33.32z",
    fill: "#53517c"
  }), React.createElement("path", {
    d: "M823.04 434.15s-22.34 9.31-20.48 12.29 20.48-12.29 20.48-12.29zM823.04 446.06s-9.29 4.11-8.52 5.42 8.52-5.42 8.52-5.42zM817.83 453.88s-9.29 4.11-8.52 5.42 8.52-5.42 8.52-5.42z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M577.1 214.58v282h283.83c-1.29-155.75-127.8-281.68-283.83-282z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M577.1 214.58v282h283.83c-1.29-155.75-127.8-281.68-283.83-282z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M577.1 209v282h283.83c-1.29-155.76-127.8-281.69-283.83-282z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M795.76 498.89a7.34 7.34 0 0 1 1.32-4.32 7.05 7.05 0 0 1 3.18-1.78c1.06-.35 2.13-.68 3.2-1a8.15 8.15 0 0 1 2.58-.42c1.78.07 3.32 1.17 4.75 2.22a2 2 0 0 1 .68.71c.32.74-.37 1.51-1 2a47.65 47.65 0 0 1-7.11 5.23c-1.78 1-4.14 2.13-6.23 2.15-2.57.07-1.54-2.93-1.37-4.79z",
    fill: "#c37871"
  }), React.createElement("path", {
    d: "M822.33 254.17c0 .8 0 1.6-.09 2.39a4.64 4.64 0 0 1-.44.26 12.9 12.9 0 0 0-1.65.73c-1.63 1.11-1.26 3.53-1.11 5.49a14.79 14.79 0 0 1-1.7 8.19 2.93 2.93 0 0 1-2.59-2.44 19.59 19.59 0 0 1-.16-3.83c-.16-3.42-2-6.47-3.2-9.69-2.22-6.17-1.73-13-3.21-19.37-.43-1.88-1.13-3.88-2.73-5-2.12-1.46-5.06-.82-7.34.37s-4.32 2.93-6.79 3.68c-3.81 1.15-7.86-.24-11.65-1.42s-8.08-2.18-11.62-.37c-3.72 1.91-5.39 6.26-6.53 10.3a10.1 10.1 0 0 0-.53 3.44c.07 1 .46 2.05.43 3.1 0 2.24-1.91 4-2.65 6.12-.46 1.31-.35 4.54-2.25 4.52a1.21 1.21 0 0 1-.61-.19 32 32 0 0 1-.61-6.3 33.16 33.16 0 0 1 .46-5.49 33.5 33.5 0 0 1 66.53 4.34c.03.4.04.79.04 1.17z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M746.97 245.8c-.12-3.23 2.33-6.25 1.77-9.43-.44-2.49-2.6-4.3-3.65-6.6a8 8 0 0 1 1.27-8.43c.82-.92 1.85-1.64 2.64-2.58 1.57-1.88 2-4.41 2.75-6.75s2-4.79 4.33-5.59c2.51-.86 5.45.54 7.87-.55a2 2 0 0 0 1.23-1.32 4.66 4.66 0 0 0-.13-1.33c-.17-1.78 1.52-3.17 3.14-3.95 7.4-3.57 16.14-1.87 24.16-.1a15.89 15.89 0 0 1 .35-4.86c5.06.56 10.51 1.3 14.17 4.82 2.27 2.19 3.54 5.17 5 7.93s3.46 5.53 6.39 6.68a7.1 7.1 0 0 1 2.64 1.26 5 5 0 0 1 1 1.68l1.92 4.73a5.26 5.26 0 0 0 .88 1.59 8.15 8.15 0 0 0 1.69 1.19c3.72 2.43 4.27 7.78 3.11 12.08s-3.58 8.19-4.5 12.55c-.54 2.57-.85 5.71-3.2 6.88a13.6 13.6 0 0 0-1.65.74c-1.63 1.1-1.27 3.52-1.11 5.48a14.83 14.83 0 0 1-1.69 8.19 2.92 2.92 0 0 1-2.59-2.44 19.52 19.52 0 0 1-.17-3.83c-.16-3.42-2-6.47-3.2-9.69-2.22-6.17-1.73-13-3.2-19.37-.44-1.89-1.15-3.88-2.75-5-2.12-1.47-5.06-.84-7.34.37s-4.31 2.92-6.78 3.67c-3.81 1.14-7.86-.23-11.66-1.43s-8.07-2.17-11.61-.36c-3.72 1.91-5.38 6.27-6.52 10.3a10.16 10.16 0 0 0-.55 3.44c.08 1 .46 2.06.44 3.1 0 2.25-1.91 4-2.65 6.13-.46 1.31-.35 4.53-2.25 4.52-1.44 0-2.9-3.26-3.61-4.21-2.17-2.89-5.79-5.56-5.94-9.51z",
    fill: "#4b3e3c"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M748.74 234.13c-.44-2.49-2.6-4.29-3.65-6.59a7.47 7.47 0 0 1-.59-2.06 7.79 7.79 0 0 0 .59 4.29c1 2.28 3.15 4.07 3.63 6.51a6.46 6.46 0 0 0 .02-2.15zM765.18 202.31a.81.81 0 0 0 0-.16 2.49 2.49 0 0 0-.12.47 1.15 1.15 0 0 0 .12-.31zM792.35 196.94a1.77 1.77 0 0 1 0-.23v.22zM829.5 234.03c-1.15 4.3-3.58 8.2-4.5 12.55-.54 2.58-.85 5.71-3.2 6.89a15.28 15.28 0 0 0-1.65.73c-1.35.92-1.33 2.74-1.19 4.46a2.92 2.92 0 0 1 1.19-2.22 13.6 13.6 0 0 1 1.65-.74c2.35-1.17 2.66-4.31 3.2-6.88.92-4.36 3.35-8.25 4.5-12.55a15.2 15.2 0 0 0 .5-5.17 15.74 15.74 0 0 1-.5 2.93zM817.35 267.88a2.92 2.92 0 0 1-2.59-2.44 19.66 19.66 0 0 1-.17-3.84c-.16-3.41-2-6.47-3.2-9.68-2.22-6.17-1.73-13-3.2-19.37-.44-1.89-1.15-3.88-2.75-5-2.12-1.46-5.06-.83-7.34.37s-4.31 2.93-6.78 3.67c-3.81 1.15-7.86-.23-11.66-1.42s-8.07-2.18-11.61-.36c-3.72 1.91-5.38 6.27-6.52 10.29a10.21 10.21 0 0 0-.55 3.45c0 .23.06.47.1.7a15.16 15.16 0 0 1 .45-1.91c1.14-4 2.8-8.39 6.52-10.3 3.54-1.81 7.82-.83 11.61.36s7.85 2.57 11.66 1.43c2.47-.75 4.5-2.47 6.78-3.67s5.22-1.84 7.34-.37c1.6 1.09 2.31 3.08 2.75 5 1.47 6.39 1 13.2 3.2 19.37 1.15 3.22 3 6.27 3.2 9.69a19.52 19.52 0 0 0 .17 3.83 2.92 2.92 0 0 0 2.59 2.44 14.88 14.88 0 0 0 1.7-8.12 15 15 0 0 1-1.7 5.88zM758.77 252.79c-.46 1.31-.35 4.53-2.25 4.52-1.44 0-2.9-3.25-3.61-4.2-2-2.71-5.26-5.2-5.85-8.69a7.12 7.12 0 0 0-.09 1.38c.15 3.95 3.77 6.62 5.94 9.54.71 1 2.17 4.2 3.61 4.21 1.9 0 1.79-3.21 2.25-4.52.74-2.12 2.6-3.88 2.65-6.13a6.12 6.12 0 0 0-.14-1.28c-.43 1.81-1.86 3.36-2.51 5.17z"
  })), React.createElement("path", {
    fill: primaryColor,
    d: "M99.75 446.6h3.36v3.42h-3.36z"
  }), React.createElement("path", {
    opacity: 0.25,
    d: "M99.75 446.6h3.36v3.42h-3.36z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M384.45 164.94h3.28v3.81h-3.28z"
  }), React.createElement("path", {
    opacity: 0.25,
    d: "M384.45 164.94h3.28v3.81h-3.28z"
  }), React.createElement("path", {
    d: "M387.76 450.03v-282h-.59c-156.31 0-283.15 126.08-284.42 282.09z",
    fill: "#fff",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M387.76 450.03v-282h-.59c-156.31 0-283.15 126.08-284.42 282.09z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M387.76 450.03v-282h-.59c-156.31 0-283.15 126.08-284.42 282.09z",
    opacity: 0.25
  }), React.createElement("path", {
    d: "M384.76 447.03v-282h-.59c-156.31 0-283.15 126.08-284.42 282.09z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M384.76 447.03v-282h-.59c-156.31 0-283.15 126.08-284.42 282.09z",
    opacity: 0.15
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M594.55 677.37l4.19 2.63v5l-5.69-.88 1.5-6.75z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M594.55 677.37l4.19 2.63v5l-5.69-.88 1.5-6.75z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M194.92 679.37l-1.57.47v5l5.32-1.16-1.31-4.87-2.44.56z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M194.92 679.37l-1.57.47v5l5.32-1.16-1.31-4.87-2.44.56z"
  }), React.createElement("path", {
    d: "M399.69 485.96L193.35 684.84a284.38 284.38 0 0 0 405.38.16z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M399.69 480.96L193.35 679.84a284.38 284.38 0 0 0 405.38.16z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M399.69 480.96L193.35 679.84a284.38 284.38 0 0 0 405.38.16z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M399.69 485.96L193.35 684.84a284.38 284.38 0 0 0 405.38.16z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#3acc6c",
    d: "M382.99 475.06l6.87-4.7 1 2-7.84 5.73-.03-3.03z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M382.99 475.06l6.87-4.7 1 2-7.84 5.73-.03-3.03z"
  }), React.createElement("path", {
    fill: "#ff748e",
    d: "M378.11 468.03l7.25-2.67 1 2-12.37 4.17 4.12-3.5z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M378.11 468.03l7.25-2.67 1 2-12.37 4.17 4.12-3.5z"
  }), React.createElement("path", {
    fill: "#5e5a6b",
    d: "M377.2 459.28l7.66-.42v2l-12.87 1.35 1.15-2.59 4.06-.34z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M377.2 459.28l7.66-.42v2l-12.87 1.35 1.15-2.59 4.06-.34z"
  }), React.createElement("path", {
    d: "M384.86 458.86l-277.35 63.16a285.39 285.39 0 0 1-6.51-60.75v-2.41z",
    fill: "#5e5a6b"
  }), React.createElement("path", {
    d: "M384.86 458.86l-277.35 63.16a285.39 285.39 0 0 1-6.51-60.75v-2.41z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M384.86 460.86l-277.35 63.16a285.39 285.39 0 0 1-6.51-60.75v-2.41z",
    fill: "#5e5a6b"
  }), React.createElement("path", {
    d: "M108.01 528.5a281.75 281.75 0 0 0 28.92 76.77l248.43-139.91z",
    fill: "#ff748e"
  }), React.createElement("path", {
    d: "M108.01 528.5a281.75 281.75 0 0 0 28.92 76.77l248.43-139.91z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M109.01 530.5a281.75 281.75 0 0 0 28.92 76.77l248.43-139.91z",
    fill: "#ff748e"
  }), React.createElement("path", {
    d: "M389.31 470.38l-248 139.69.12.22a284.37 284.37 0 0 0 46.4 62.09l202-202z",
    fill: "#3acc6c"
  }), React.createElement("path", {
    d: "M389.31 470.38l-248 139.69.12.22a284.37 284.37 0 0 0 46.4 62.09l202-202z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M390.31 472.38l-248 139.69.12.22a284.37 284.37 0 0 0 46.4 62.09l202-202z",
    fill: "#3acc6c"
  }));
};

UndrawPieChart.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawPieChart;